import { lazy } from "react";

export const LazyUTBTypeListPage = lazy(async () => ({
    default: (await import("./UTBTypeListPage")).UTBTypeListPage
}));

export const LazyUTBTypePage = lazy(async () => ({
    default: (await import("./UTBTypePage")).UTBTypePage
}));

export const LazyUTBTypeFirmQuestionsPage = lazy(async () => ({
    default: (await import("./UTBTypeFirmQuestionsPage"))
        .UTBTypeFirmQuestionsPage
}));
